import { useMutation } from '@tanstack/react-query';
import { ErrorResponse, globalErrorResponse } from '../../../../shared/notification/actions';
import { invalidateReserveReportSummary } from './useReserveReportSummary';
import { apiReopenReserveList } from './apiReopenReserveList';

export function useReopenReserveList(reserveListId: string) {
    return useMutation<void, ErrorResponse, void>(() => apiReopenReserveList(reserveListId), {
        onSuccess: () => {
            invalidateReserveReportSummary(reserveListId).then();
        },
        onError: error => globalErrorResponse(error)
    });
}
